module.exports = __webpack_public_path__ + "static/img/couponTips-boxshare.3d437f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/member/couponTips-boxshare.png
// module id = YhzP
// module chunks = 156